import createClient from 'openapi-fetch'
import type { paths } from './schema.gen'
import { auth } from '../auth/firebase'
import { env } from '../config/env'

export const api = createClient<paths>({
  baseUrl: env.apiBaseUrl,
})

api.use({
  async onRequest({ request }) {
    const token = await auth.currentUser?.getIdToken()
    if (token) request.headers.set('Authorization', `Bearer ${token}`)
    return request
  },
})
